import request from "../../../../global_functions/request";
import * as R from "ramda";

import {
  bugsnagGeneralErrorHandler,
  bugsnagPostgrestErrorHandler,
} from "../../../../global_functions/postgrestApi/common";
import { VITE_UPLOAD_BASE_URL } from "../../../../env";
import FetchClients, {
  ClientOutput,
} from "@src/global_functions/backpackSdk/client";

const baseUrl = `${VITE_UPLOAD_BASE_URL}/project-attachment`;

export const getProjectAttachmentPreviews = async (
  projectId: number
): Promise<{
  [key: string]: string;
}> =>
  request
    .get(`${baseUrl}/preview?project_id=${projectId}`)
    .then((res) => res.body)
    .catch((error) => bugsnagGeneralErrorHandler(error));

export const uploadProjectAttachment = async (
  projectId: number,
  file: File
): Promise<void> =>
  await request
    .post(`${baseUrl}/upload?project_id=${projectId}&filename=${file.name}`)
    .set("Content-Type", "text/plain")
    .send(file)
    .then((res) => res.body)
    .catch((error) => bugsnagGeneralErrorHandler(error));

export const downloadProjectAttachment = async (
  attachmentId: string | number
): Promise<string> =>
  // @ts-expect-error - TS2322 - Type 'string | void' is not assignable to type 'string'.
  request
    .get(`${baseUrl}/download?attachment_id=${attachmentId}`)
    .then((res) => res.text)
    .catch((error) => bugsnagGeneralErrorHandler(error));

// rewards - @todo peter move to FETCH clients once https://bractlet.atlassian.net/browse/INNO-786 is resolved
const rewardsBaseUrl = `${VITE_UPLOAD_BASE_URL}/reward-receipt`;
export const getRewardReceiptPreviews = (
  reward_id: number
): Promise<{
  [key: string]: string;
}> =>
  request
    .get(`${rewardsBaseUrl}/preview`)
    .query({ reward_id })
    .then((res) => res.body)
    .catch((error) => bugsnagGeneralErrorHandler(error));

export const uploadRewardReceipt = (
  project_id: number,
  file: File
): Promise<void> =>
  request
    .post(`${rewardsBaseUrl}/upload`)
    .set("Content-Type", "text/plain")
    .query({ project_id, filename: file.name })
    .send(file)
    .then((res) => res.body)
    .catch((error) => bugsnagGeneralErrorHandler(error));

export const downloadRewardReceipt = (
  receipt_id: number
): Promise<string | void> =>
  request
    .get(`${rewardsBaseUrl}/download`)
    .query({ receipt_id })
    .then((res) => res.text)
    .catch((error) => bugsnagGeneralErrorHandler(error));

const attachmentCipher = (
  data:
    | Array<ClientOutput["projects"]["ProjectAttachment"]>
    | Array<ClientOutput["projects"]["RewardReceipt"]>
) => {
  return R.sortWith(
    [
      R.ascend(R.compose(R.toLower, R.prop("filename"))),
      R.ascend(R.prop("version")),
    ],
    data.map((attachment) => {
      const { project_id, uploaded_at, ...rest } = attachment;
      return {
        ...rest,
        uploaded_at: new Date(uploaded_at).toISOString(),
      };
    })
  );
};

export async function getBackpackProjectAttachmentInformation(
  project_id: number
) {
  const { data, error } = await FetchClients.projects.GET("/attachments", {
    params: {
      query: {
        project_id,
      },
    },
  });
  if (data) {
    return attachmentCipher(data);
  }
  // @todo throw an error and handle in component once projects-rewards flag is removed
  bugsnagPostgrestErrorHandler(error);
  return [];
}

export async function getRewardReceiptInformation(project_id: number) {
  const { data, error } = await FetchClients.projects.GET(
    "/{project_id}/reward_receipts",
    {
      params: {
        path: {
          project_id,
        },
      },
    }
  );
  if (data) {
    return attachmentCipher(data);
  }
  // @todo throw an error and handle in component once projects-rewards flag is removed
  bugsnagPostgrestErrorHandler(error);
  return [];
}
